import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { SessionFacade } from '@shared/store/session.facade';
import { ButtonColor, ButtonSize } from '@widgets/eop-button/eop-button.component';
import { IconColor } from '@widgets/eop-icon/eop-icon.component';

export interface InfoMessageItem {
  id: string;
  messageKey: string;
  link?: string;
  linkTextKey?: string;
  entities?: InfoMessageItemEntity[];
}

export interface InfoMessageItemEntity {
  id: string;
  name: string;
}

@Component({
  selector: 'eop-info-messages',
  templateUrl: './info-messages.component.html',
  styleUrl: './info-messages.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class InfoMessagesComponent {
  @Input()
  message: InfoMessageItem;

  sessionFacade: SessionFacade = inject(SessionFacade);

  protected readonly IconColor = IconColor;
  protected readonly ButtonColor = ButtonColor;
  protected readonly ButtonSize = ButtonSize;

  closeMessage(id: string): void {
    this.sessionFacade.closeInfoMessage(id);
  }
}
